import React from "react";
import "./RoomPage.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSadTear } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function RoomNotFoundPage() {
  return (
    <div className="vh-100 d-flex flex-row flex-wrap align-items-center justify-content-center">
      <div className="d-flex flex-column align-items-center ">
        <FontAwesomeIcon icon={faSadTear} size="8x" className="text-muted" />
        <h2 className="text-muted m-4">Room no longer exists</h2>
        <Link to="/">
          <button type="button" className="btn btn btn-outline-secondary">
            Start New Room
          </button>
        </Link>
      </div>
    </div>
  );
}
